/* GLLF Lavender Farm Planner prices v1: real plant prices in "Shop this plan" (retail and wholesale, using the same
   wholesale tiers as the Wholesale reservation) and the plant cost filled in so the project estimate isn't $0. */
(function () {
  'use strict';
  var z = document.getElementById('gllfFarmPlanner');
  if (!z || z.dataset.wsPrices) return;
  z.dataset.wsPrices = '1';
  var FORMATS = {
    t72: { col: '72-cell-lavender-trays', re: /72.?cell/i, per: 72, unit: 'tray', minPlants: 144 },
    t20: { col: '20-cell-lavender-trays', re: /20.?cell/i, per: 20, unit: 'tray', minPlants: 60 },
    bare: { col: 'bare-root-lavender', re: /bare.?root/i, per: 1, unit: 'plant', minPlants: 25 },
    plug3: { col: '3-inch-lavender-plugs', re: /3.?inch/i, per: 1, unit: 'plug', minPlants: 0 },
    pot4: { col: '4-inch-lavender-pots', re: /4.?inch/i, per: 1, unit: 'pot', minPlants: 0 },
    gal: { col: '1-gallon-lavender-plants', re: /gallon/i, per: 1, unit: 'pot', minPlants: 0 }
  };
  var TIERS = [[50000, 0.6], [30000, 0.58], [15000, 0.56], [5000, 0.54], [1000, 0.52]];
  function rate(retailTotal) { var half = retailTotal / 2; for (var i = 0; i < TIERS.length; i++) if (half >= TIERS[i][0]) return TIERS[i][1]; return 0.5; }
  function money(n) { return '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: n >= 1000 ? 0 : 2, maximumFractionDigits: n >= 1000 ? 0 : 2 }); }
  function num(s) { var m = String(s || '').replace(/,/g, '').match(/\d+(\.\d+)?/); return m ? parseFloat(m[0]) : 0; }
  var prices = {}, ready = false;

  function load(key) {
    var f = FORMATS[key];
    return fetch('/collections/' + f.col + '/products.json?limit=100').then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) {
      var count = {};
      (j.products || []).forEach(function (p) { (p.variants || []).forEach(function (v) { if (f.re.test(v.title + ' ' + (v.option1 || ''))) { var k = String(+v.price); count[k] = (count[k] || 0) + 1; } }); });
      var best = Object.keys(count).sort(function (a, b) { return count[b] - count[a] || a - b; })[0];
      if (best && +best > 0) prices[key] = +best;
    }).catch(function () {});
  }

  function formatOf(href) { for (var k in FORMATS) if (String(href || '').indexOf('/collections/' + FORMATS[k].col) !== -1) return k; return null; }

  function tiles() {
    z.querySelectorAll('.gps-shopgrid a').forEach(function (a) {
      var key = formatOf(a.getAttribute('href')), retail = key && prices[key];
      if (!retail) return;
      var f = FORMATS[key], qty = num((a.querySelector('strong') || {}).textContent), r = rate(qty * retail);
      var unit = retail * (1 - r), text = money(unit) + ' a ' + f.unit + ' wholesale (retail ' + money(retail) + ')' + (qty ? ' · about ' + money(qty * unit) + ' for ' + qty.toLocaleString('en-US') + ' ' + f.unit + (qty === 1 ? '' : 's') : '');
      var tag = a.querySelector('[data-ws-price]');
      if (!tag) { tag = document.createElement('small'); tag.setAttribute('data-ws-price', ''); tag.style.cssText = 'display:block;margin-top:.35em;font-weight:600;color:inherit;opacity:.92'; a.appendChild(tag); }
      if (tag.textContent !== text) tag.textContent = text;
    });
  }

  var lastAuto = null, manual = false;
  z.addEventListener('input', function (e) { if (e.isTrusted && e.target && e.target.id === 'gfpPlantCost') manual = true; }, true);
  function plantCost() {
    var input = z.querySelector('#gfpPlantCost'); if (!input || manual) return;
    var cur = parseFloat(input.value) || 0;
    if (cur && (lastAuto == null || Math.abs(cur - lastAuto) > 0.004)) { manual = true; return; }
    var pick = z.querySelector('.gps-shopgrid a.is-pick'), key = pick ? formatOf(pick.getAttribute('href')) : null;
    var plants = num((z.querySelector('[data-m="plants"]') || {}).textContent);
    if (!key || !prices[key] || !plants) return;
    var f = FORMATS[key], items = Math.ceil(plants / f.per), wholesale = f.minPlants > 0 && items * f.per >= f.minPlants;
    var each = (wholesale ? prices[key] * (1 - rate(items * prices[key])) : prices[key]) / f.per;
    each = Math.round(each * 100) / 100;
    var hint = input.parentElement && input.parentElement.querySelector('[data-ws-hint]');
    if (!hint && input.parentElement) { hint = document.createElement('small'); hint.setAttribute('data-ws-hint', ''); hint.style.cssText = 'display:block;margin-top:.3em'; input.parentElement.appendChild(hint); }
    var note = 'Filled in from the ' + (wholesale ? 'wholesale ' : '') + (key === 't72' ? '72-cell tray' : key === 't20' ? '20-cell tray' : key === 'bare' ? 'bare-root' : f.unit) + ' price. Change it if you like.';
    if (hint && hint.textContent !== note) hint.textContent = note;
    if (Math.abs(each - cur) < 0.004) { lastAuto = each; return; }
    lastAuto = each;
    input.value = each.toFixed(2);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* The planner repaints "Shop this plan" often, so prices go back on in the same tick (no flicker). */
  var queued = false;
  function run() { if (!ready) return; tiles(); if (queued) return; queued = true; setTimeout(function () { queued = false; plantCost(); }, 150); }
  Promise.all(Object.keys(FORMATS).map(load)).then(function () { ready = true; run(); });
  new MutationObserver(run).observe(z, { childList: true, subtree: true });
})();
